// Ported from Dealtracker src/appframe/tours/markdown.tsx (commit 30ca0cb); inline styles → classes.
import { Fragment, type ReactNode } from 'react';

/**
 * The tiny markdown subset a tour step body may use: `**bold**`, `- ` list items, and a
 * blank line between paragraphs. Anything else is shown as plain text (no HTML parsing).
 */
function inline(text: string): ReactNode[] {
  return text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, i) =>
    part.startsWith('**') && part.endsWith('**') && part.length > 4
      ? <strong key={i}>{part.slice(2, -2)}</strong>
      : <Fragment key={i}>{part}</Fragment>,
  );
}

export function TourMarkdown({ text }: { text: string }) {
  const blocks = text.trim().split(/\n\s*\n/);
  return (
    <>
      {blocks.map((block, b) => {
        const lines = block.split('\n').map(l => l.trim()).filter(Boolean);
        if (lines.length > 0 && lines.every(l => l.startsWith('- '))) {
          return (
            <ul key={b} className="tour-md-list">
              {lines.map((l, i) => <li key={i}>{inline(l.slice(2))}</li>)}
            </ul>
          );
        }
        return <p key={b} className="tour-md-p">{inline(lines.join(' '))}</p>;
      })}
    </>
  );
}

/** The same text without markup, for the screen-reader announcement. */
export function tourMarkdownToPlain(text: string): string {
  return text
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/^\s*- /gm, '')
    .replace(/\s+/g, ' ')
    .trim();
}
